// Business Logic Constants Configuration
// This file centralizes all business logic constants from environment variables

// Output Format Constants
export const OUTPUT_FORMATS = {
  IMAGE: {
    ID: parseInt(process.env.REACT_APP_IMAGE_FORMAT_ID) || 1,
    NAME: 'IMAGE'
  },
  VIDEO: {
    ID: parseInt(process.env.REACT_APP_VIDEO_FORMAT_ID) || 2,
    NAME: 'VIDEO'
  }
};

// Model Type Constants
export const MODEL_TYPES = {
  BUST: {
    ID: parseInt(process.env.REACT_APP_BUST_MODEL_TYPE_ID) || 1,
    NAME: 'BUST'
  },
  HUMAN: {
    ID: parseInt(process.env.REACT_APP_HUMAN_MODEL_TYPE_ID) || 2,
    NAME: 'HUMAN'
  }
};

// Country Constants
export const COUNTRIES = {
  INDIA: {
    ID: parseInt(process.env.REACT_APP_INDIA_COUNTRY_ID) || 2,
    NAME: 'INDIA'
  }
};

// Status Constants
export const STATUS = {
  ACTIVE: {
    ID: parseInt(process.env.REACT_APP_ACTIVE_STATUS_ID) || 1,
    NAME: 'ACTIVE'
  },
  INACTIVE: {
    ID: parseInt(process.env.REACT_APP_INACTIVE_STATUS_ID) || 0,
    NAME: 'INACTIVE'
  }
};

// Permission Constants
export const PERMISSIONS = {
  ALLOW: {
    ID: parseInt(process.env.REACT_APP_PERMISSION_ALLOW_ID) || 1,
    NAME: 'ALLOW'
  },
  DENY: {
    ID: parseInt(process.env.REACT_APP_PERMISSION_DENY_ID) || 0,
    NAME: 'DENY'
  }
};

// Helper functions for format checking
export const isImageFormat = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.IMAGE.ID;
};

export const isVideoFormat = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.VIDEO.ID;
};

// Helper functions for model type checking
export const isBustModel = (modelTypeId) => {
  return modelTypeId === MODEL_TYPES.BUST.ID;
};

export const isHumanModel = (modelTypeId) => {
  return modelTypeId === MODEL_TYPES.HUMAN.ID;
};

// Helper functions for country checking
export const isIndiaCountry = (countryId) => {
  return countryId === COUNTRIES.INDIA.ID;
};

// Helper functions for status checking
export const isActiveStatus = (statusId) => {
  return statusId === STATUS.ACTIVE.ID;
};

export const isInactiveStatus = (statusId) => {
  return statusId === STATUS.INACTIVE.ID;
};

// Helper functions for permission checking
export const isPermissionAllow = (permissionTypeId) => {
  return permissionTypeId === PERMISSIONS.ALLOW.ID;
};

export const isPermissionDeny = (permissionTypeId) => {
  return permissionTypeId === PERMISSIONS.DENY.ID;
};

// Feature Flags
export const FEATURE_FLAGS = {
  SHOW_SMS_WHATSAPP_AUTH: {
    ENABLED: process.env.REACT_APP_SHOW_SMS_WHATSAPP_AUTH === 'true',
    NAME: 'SHOW_SMS_WHATSAPP_AUTH'
  }
};

// Helper function to check if SMS/WhatsApp auth should be shown
// For webapp: always show (return true)
// For Flutter app: only show if environment variable is set to 'true'
export const shouldShowSmsWhatsAppAuth = (isFlutterApp = false) => {
  // If it's a webapp (not Flutter app), always show SMS/WhatsApp auth
  if (!isFlutterApp) {
    return true;
  }
  
  // If it's a Flutter app, check the environment variable
  return FEATURE_FLAGS.SHOW_SMS_WHATSAPP_AUTH.ENABLED;
};

// Get name by ID functions
export const getFormatNameById = (outputFormatId) => {
  if (outputFormatId === OUTPUT_FORMATS.IMAGE.ID) return OUTPUT_FORMATS.IMAGE.NAME;
  if (outputFormatId === OUTPUT_FORMATS.VIDEO.ID) return OUTPUT_FORMATS.VIDEO.NAME;
  return 'UNKNOWN';
};

export const getModelTypeNameById = (modelTypeId) => {
  if (modelTypeId === MODEL_TYPES.BUST.ID) return MODEL_TYPES.BUST.NAME;
  if (modelTypeId === MODEL_TYPES.HUMAN.ID) return MODEL_TYPES.HUMAN.NAME;
  return 'UNKNOWN';
};

export const getStatusNameById = (statusId) => {
  if (statusId === STATUS.ACTIVE.ID) return STATUS.ACTIVE.NAME;
  if (statusId === STATUS.INACTIVE.ID) return STATUS.INACTIVE.NAME;
  return 'UNKNOWN';
};

export const getPermissionNameById = (permissionTypeId) => {
  if (permissionTypeId === PERMISSIONS.ALLOW.ID) return PERMISSIONS.ALLOW.NAME;
  if (permissionTypeId === PERMISSIONS.DENY.ID) return PERMISSIONS.DENY.NAME;
  return 'UNKNOWN';
};

// Validation functions
export const isValidFormatId = (outputFormatId) => {
  return outputFormatId === OUTPUT_FORMATS.IMAGE.ID || outputFormatId === OUTPUT_FORMATS.VIDEO.ID;
};

export const isValidModelTypeId = (modelTypeId) => {
  return modelTypeId === MODEL_TYPES.BUST.ID || modelTypeId === MODEL_TYPES.HUMAN.ID;
};

export const isValidStatusId = (statusId) => {
  return statusId === STATUS.ACTIVE.ID || statusId === STATUS.INACTIVE.ID;
};

export const isValidPermissionTypeId = (permissionTypeId) => {
  return permissionTypeId === PERMISSIONS.ALLOW.ID || permissionTypeId === PERMISSIONS.DENY.ID;
};

// Export all constants
export default {
  OUTPUT_FORMATS,
  MODEL_TYPES,
  COUNTRIES,
  STATUS,
  PERMISSIONS,
  FEATURE_FLAGS
};
